/**
 * Journal articles — hide broken images; soften links to retired products in prose.
 */
(function () {
  function scheduleIdle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: timeout || 2500 });
    } else {
      setTimeout(fn, 800);
    }
  }

  function hideBrokenImage(img) {
    if (!img || img.dataset.brokenHandled === '1') return;
    img.dataset.brokenHandled = '1';

    var figure = img.closest('figure');
    if (figure) {
      figure.hidden = true;
      figure.setAttribute('aria-hidden', 'true');
    } else {
      img.hidden = true;
      var parent = img.parentElement;
      if (
        parent &&
        (parent.tagName === 'P' || parent.tagName === 'DIV') &&
        parent.textContent.trim() === '' &&
        parent.children.length === 1
      ) {
        parent.hidden = true;
        parent.setAttribute('aria-hidden', 'true');
      }
    }

    var gallery = img.closest('.article-journal__gallery');
    if (gallery && !gallery.querySelector('figure:not([hidden])')) {
      gallery.hidden = true;
      gallery.setAttribute('aria-hidden', 'true');
    }
  }

  function bindBrokenImages(root) {
    if (!root) return;
    root.querySelectorAll('img').forEach(function (img) {
      if (img.closest('blockquote[data-instgrm-permalink], blockquote.article-journal__instagram-fallback')) {
        return;
      }
      if (img.complete && img.naturalWidth === 0 && img.src) {
        hideBrokenImage(img);
        return;
      }
      img.addEventListener('error', function onError() {
        img.removeEventListener('error', onError);
        hideBrokenImage(img);
      });
    });
  }

  function instagramLabelFromBlockquote(blockquote) {
    var links = blockquote.querySelectorAll('a[href*="instagram.com/p/"]');
    if (links.length) {
      return links[links.length - 1].textContent.trim();
    }
    return 'View this post on Instagram';
  }

  function renderInstagramFallback(blockquote, permalink, label) {
    blockquote.classList.remove('instagram-media');
    blockquote.removeAttribute('data-instgrm-permalink');
    blockquote.removeAttribute('data-instgrm-version');
    blockquote.dataset.ytIgFallback = '1';
    blockquote.classList.add('article-journal__instagram-fallback');
    blockquote.innerHTML =
      '<a class="article-journal__instagram-fallback-link" href="' +
      permalink +
      '" target="_blank" rel="noopener noreferrer">' +
      '<span class="article-journal__instagram-fallback-icon" aria-hidden="true"></span>' +
      '<span class="article-journal__instagram-fallback-text">' +
      label +
      '</span>' +
      '<span class="article-journal__instagram-fallback-cta">Open on Instagram</span>' +
      '</a>';
  }

  function processInstagramEmbedsOnce() {
    if (window.__ytIgEmbedProcessed) return;
    if (!window.instgrm || !window.instgrm.Embeds) return;
    if (!document.querySelector('.article-journal__body blockquote[data-instgrm-permalink]')) return;

    window.__ytIgEmbedProcessed = true;
    window.instgrm.Embeds.process();
  }

  function waitForEmbedJs() {
    function tryProcess() {
      processInstagramEmbedsOnce();
    }

    if (window.instgrm && window.instgrm.Embeds) {
      tryProcess();
      return;
    }

    var existing = document.querySelector('script[src*="instagram.com/embed.js"]');
    if (existing) {
      existing.addEventListener('load', tryProcess, { once: true });
      setTimeout(tryProcess, 1000);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.onload = tryProcess;
    document.body.appendChild(script);
    setTimeout(tryProcess, 1000);
  }

  function initInstagramEmbeds(root) {
    if (!root || root.dataset.ytIgInit === '1') return;

    var embeds = root.querySelectorAll('blockquote[data-instgrm-permalink]');
    if (!embeds.length) return;

    root.dataset.ytIgInit = '1';

    embeds.forEach(function (blockquote) {
      var permalink = blockquote.getAttribute('data-instgrm-permalink') || '';
      if (permalink.indexOf('/p/CcSmMEJLFNM/') !== -1) {
        renderInstagramFallback(
          blockquote,
          'https://www.instagram.com/p/CcSmMEJLFNM/',
          instagramLabelFromBlockquote(blockquote)
        );
        return;
      }

      blockquote.classList.add('instagram-media');
    });

    waitForEmbedJs();
  }

  function initDownloadBlocks(root) {
    if (!root) return;

    root.querySelectorAll('[data-yt-download]').forEach(function (block) {
      var trigger = block.querySelector('[data-yt-download-trigger]');
      var followup = block.querySelector('[data-yt-download-followup]');
      if (!trigger || !followup) return;

      var storageKey = 'yt-download-followup:' + (block.getAttribute('aria-label') || 'habit-tracker');

      function revealFollowup() {
        followup.hidden = false;
        try {
          sessionStorage.setItem(storageKey, '1');
        } catch (e) {}
      }

      try {
        if (sessionStorage.getItem(storageKey) === '1') {
          revealFollowup();
        }
      } catch (e) {}

      trigger.addEventListener('click', function () {
        window.setTimeout(revealFollowup, 400);
      });
    });
  }

  function initDeferredTrustpilot() {
    var el = document.querySelector('[data-yt-defer-trustpilot]');
    if (!el) return;

    if (!('IntersectionObserver' in window)) {
      el.hidden = false;
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        el.hidden = false;
        observer.disconnect();
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
  }

  function imageStem(src) {
    if (!src) return '';
    return src
      .split('?')[0]
      .split('/')
      .pop()
      .replace(/_([a-f0-9]{8,})\.(jpg|jpeg|png|webp)$/i, '.$2')
      .toLowerCase();
  }

  function dedupeFeaturedInProse(root) {
    if (!root) return;
    var featuredImg = root.querySelector('.article-journal__featured-img');
    var prose = root.querySelector('.article-journal__prose');
    if (!featuredImg || !prose) return;

    var featuredStem = imageStem(featuredImg.currentSrc || featuredImg.src);
    if (!featuredStem) return;

    prose.querySelectorAll('figure img').forEach(function (img) {
      if (imageStem(img.currentSrc || img.src) !== featuredStem) return;
      hideBrokenImage(img);
    });
  }

  function unwrapLink(link) {
    var span = document.createElement('span');
    span.innerHTML = link.innerHTML;
    link.replaceWith(span);
  }

  function checkProductLinks(links) {
    var linksByHandle = {};
    links.forEach(function (link) {
      var match = link.pathname.match(/\/products\/([^/]+)/);
      if (!match) return;
      var handle = match[1];
      if (!linksByHandle[handle]) linksByHandle[handle] = [];
      linksByHandle[handle].push(link);
    });

    var handles = Object.keys(linksByHandle);
    if (!handles.length) return;

    var index = 0;
    var batchSize = 2;

    function nextBatch() {
      var batch = handles.slice(index, index + batchSize);
      index += batchSize;
      if (!batch.length) return;

      Promise.all(
        batch.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (res) {
              if (!res.ok) return { handle: handle, available: null };
              return res.json().then(function (product) {
                return { handle: handle, available: product.available };
              });
            })
            .catch(function () {
              return { handle: handle, available: null };
            });
        })
      ).then(function (results) {
        results.forEach(function (result) {
          if (result.available !== false) return;
          linksByHandle[result.handle].forEach(unwrapLink);
        });
        if (index < handles.length) scheduleIdle(nextBatch);
      });
    }

    scheduleIdle(nextBatch);
  }

  function init() {
    var body = document.querySelector('.article-journal__body');
    if (!body) return;

    dedupeFeaturedInProse(body);
    bindBrokenImages(body);
    initInstagramEmbeds(body);
    initDownloadBlocks(body);
    initDeferredTrustpilot();

    var prose = document.querySelector('.article-journal__prose');
    if (!prose) return;

    var links = prose.querySelectorAll('a[href*="/products/"]');
    if (!links.length) return;

    checkProductLinks(links);
  }

  scheduleIdle(init, 1500);
})();
